export const subtitles = {
    "1": {
        "startTime": 0.11,
        "endTime": 6.71,
        "transcript": "...Neresgaam-wa-am tua-i teggikcitagauteksaqlikii tuaten.",
        "translation": "...Neresgaaq would probably laugh about it like that."
    },
    "2": {
        "startTime": 8.41,
        "endTime": 17.21,
        "transcript": "Kitak' tua-i au͡gkunek qanengssauteqernga niirqelallerpenek iciw' Kass'at tekiteqerraallrat. Taumek-wa paacamek pillilria.",
        "translation": "Can you talk to me about what you heard about the first Western contact? They probably mean the barge."
    },
    "3": {
        "startTime": 17.295,
        "endTime": 18.195,
        "transcript": "Aa?",
        "translation": "Huh?"
    },
    "4": {
        "startTime": 19.08,
        "endTime": 27.54,
        "transcript": "Angyarpak iciw' im'u, tamakut niitelalten iciw' temcinarqellriit irr'ikellrit makut Yuut wani.",
        "translation": "The large sea vessel, you know, the funny things you used to hear about what Yupiit were amazed by."
    },
    "5": {
        "startTime": 27.685,
        "endTime": 30.665,
        "transcript": "Ciumek-qaa qanemcillaken tamatumek?",
        "translation": "Should I tell you stories about that first?"
    },
    "6": {
        "startTime": 31.05,
        "endTime": 31.66,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "7": {
        "startTime": 32.22,
        "endTime": 35.68,
        "transcript": "Amllermek-wa taktumek qalarrngailngua. (Canrituq.)",
        "translation": "I won't say too much about a long story. (That's okay.)"
    },
    "8": {
        "startTime": 36.205,
        "endTime": 43.105,
        "transcript": "Cali-ll' tua-i camek tua-i qanerkamnek qanqerraarlua taktuamek qalartevkenii piciua.",
        "translation": "And after I say what I need to say, I won't speak for too long."
    },
    "9": {
        "startTime": 46.93,
        "endTime": 57.96,
        "transcript": "Niitetullruunga qanengssalrianek maaten ellangua wii angalkumek taumek ikani Apruka'armiuni wagg'uq uumek Ississaayugmek.",
        "translation": "I grew up hearing hearsay about a shaman who lived across in Apruka'armiut whom they called Ississaayuk."
    },
    "10": {
        "startTime": 59.22,
        "endTime": 62.89,
        "transcript": "Cauyainanermini-gguq qanlangellruuq.",
        "translation": "They said that he would start speaking as he was drumming."
    },
    "11": {
        "startTime": 63.73,
        "endTime": 73.45,
        "transcript": "Tangrriu-gguq ilakumanrilnguut allayuut yuut puqlam tungiikun amaggun qagrutellriit.",
        "translation": "They said to see that unrelated different people would burst out through the warmth."
    },
    "12": {
        "startTime": 74.795,
        "endTime": 79.095,
        "transcript": "Taukunek tua-i qaneryaurtelliniluni.",
        "translation": "He learned to speak with those."
    },
    "13": {
        "startTime": 80.33,
        "endTime": 86.32,
        "transcript": "Atam-gguq caqerluku ellii pinguaresqekiit tangerrsungluteng.",
        "translation": "They said that one day, they asked him to do it because they wanted to see it."
    },
    "14": {
        "startTime": 88.56,
        "endTime": 97.21,
        "transcript": "Tua-i maligtaqulluni tua-i pingualliniluni Kass'arualliniluni.",
        "translation": "He complied and spoke like a Westerner."
    },
    "15": {
        "startTime": 98.33,
        "endTime": 106.22,
        "transcript": "Tayima tua-i mat'um qanemcim ilii katagaluku tua-i piunga.",
        "translation": "I'm probably telling this story forgetting about some parts."
    },
    "16": {
        "startTime": 107.26,
        "endTime": 115.57,
        "transcript": "Kiagan-gguq Kusquqvaq tua-i cupngan cun'akayak tamana Kusquqvagkun asgurtuq.",
        "translation": "They said that when summer set and the ice on the Kuskokwim broke, a huge ship went upriver through the Kuskokwim."
    },
    "17": {
        "startTime": 116.78,
        "endTime": 123.32,
        "transcript": "Ikavet-llu-gguq tua-i Ciniim ketiinun arulairluni, Qemiterak ketiigni.",
        "translation": "And they say it stopped across there toward the water from Cinik, toward the water from Qemiterak."
    },
    "18": {
        "startTime": 124.585,
        "endTime": 137.305,
        "transcript": "Qayakun-gguq tua-i ullagallermeggni anguarluteng paqnayulriit kenegnarqenrilnguut tamakut tuquinerraralriit wall' aglenra'rnek irnialget",
        "translation": "They say that when the curious unsuitable ones went to go see it paddling kayaks, the ones who recently lost family members or whose daughters were in their first years of menstruations"
    },
    "19": {
        "startTime": 138.85,
        "endTime": 144.5,
        "transcript": "Tekitarkaunrirqamegteggu utertetullruut mallegciiganaku.",
        "translation": "When they couldn't reach it, they would go home, unable to get close to it."
    },
    "20": {
        "startTime": 146.18,
        "endTime": 149.99,
        "transcript": "Tamakut-gguq cakun ilaita tekitlauraat",
        "translation": "They say that only a select few would reach it"
    },
    "21": {
        "startTime": 151.15,
        "endTime": 156.41,
        "transcript": "Cun'akayak tamana pugtalria Kass'arugarnek yugyagluni.",
        "translation": "That huge floating ship had a lot of Caucasians."
    },
    "22": {
        "startTime": 156.935,
        "endTime": 162.675,
        "transcript": "Qacarnerani-gguq man'a iqutmun iit qelemyuraqluteng.",
        "translation": "They said that on the side toward the end, their eyes tended to shut."
    },
    "23": {
        "startTime": 164.86,
        "endTime": 171.07,
        "transcript": "Qanqata'arqameng-gguq tamakut ellmeggnun qanruyuteqatalliniaqameng",
        "translation": "They said that when they were going to speak, speak amongst themselves"
    },
    "24": {
        "startTime": 171.73,
        "endTime": 177.59,
        "transcript": "Aa-aqaarararraarluteng tau͡gaam qit'vutaqluteng ilameggnun.",
        "translation": "They would only speak English to their peers after going \"aa-a.\""
    },
    "25": {
        "startTime": 179.135,
        "endTime": 182.085,
        "transcript": "Naparterluni-gguq malrugnek.",
        "translation": "They said that it had two masts."
    },
    "26": {
        "startTime": 183.455,
        "endTime": 192.715,
        "transcript": "Napartek-gguq akulmeliitaagni pagaani ilavkugkun tuntuyagarpak angitaaruarturalria.",
        "translation": "They said that on the ropes between the masts up there, a little moose was repeatedly untying."
    },
    "27": {
        "startTime": 194.4,
        "endTime": 203.03,
        "transcript": "Pikna-wa-gguq call' Kass'aq atauciq calaraq eniumaurluku tua-i.",
        "translation": "They also said that one Caucasian up there was always pointing to the east."
    },
    "28": {
        "startTime": 205.0,
        "endTime": 207.83,
        "transcript": "Tallia-kiq mernungyuipagta.",
        "translation": "Doesn't his arm ever get tired?"
    },
    "29": {
        "startTime": 209.03,
        "endTime": 212.21,
        "transcript": "Tua-i-w' compass-aaqelliniluku tauna.",
        "translation": "He was their compass."
    },
    "30": {
        "startTime": 214.445,
        "endTime": 222.755,
        "transcript": "Tauna tua-i cali niitetellruunga Illugngalimek taumek, ciuqvani qanemcimek.",
        "translation": "I also used to hear about Illugngali, an old story."
    },
    "31": {
        "startTime": 223.865,
        "endTime": 227.395,
        "transcript": "Illugngalikayak tauna piquarilnguq.",
        "translation": "The infamous Illugngali who was not short tempered."
    },
    "32": {
        "startTime": 230.685,
        "endTime": 242.385,
        "transcript": "Tua-i-gguq tauna atrallrani, qakuni kinguaqliani tau͡gaam pilliuq? Ciuqliatni pillrunritliuq?",
        "translation": "They said that his name, it may have happened after. It may not have happened before."
    },
    "33": {
        "startTime": 244.26,
        "endTime": 253.84,
        "transcript": "Tauna-gguq tua-i... kinguqlianun tayima eviarqa elliciqaqa au͡gna Illugngali, ai?",
        "translation": "They said that he... I will place my [?] Illugngali later, okay?"
    },
    "34": {
        "startTime": 255.295,
        "endTime": 258.305,
        "transcript": "Kass'at-gguq Kallugngalimek pitullruat.",
        "translation": "They said the Caucasians called him Kallugngali."
    },
    "35": {
        "startTime": 259.855,
        "endTime": 267.055,
        "transcript": "Tut'ellriit-gguq taukut Kusquqviim atanranek yuallruut taumek Illugngalimek aterpagtaarluku.",
        "translation": "They said that the ones who arrived looked for the leader of the Kuskokwim, calling him Illugngali."
    },
    "36": {
        "startTime": 267.91,
        "endTime": 270.21,
        "transcript": "Amta-llu-gguq nalluluku.",
        "translation": "And yet they say they didn't know him."
    },
    "37": {
        "startTime": 272.415,
        "endTime": 279.945,
        "transcript": "Allamiani-gguq taman' cun'aq tekituq alla. Allakauluni tuaten ayuqevkenani.",
        "translation": "They said that the next year, another ship came. It was different, unlike that one."
    },
    "38": {
        "startTime": 282.115,
        "endTime": 288.375,
        "transcript": "Aklunek-gguq tua-i tunturiluni piksunarqelrianek assilrianek.",
        "translation": "They said that it started giving out good things that people wanted."
    },
    "39": {
        "startTime": 289.732,
        "endTime": 304.499,
        "transcript": "Tauna-gguq tua-i Ississaayuum pania tamaani tamaani tunturillrani aklunek cun'anek, cun'aq tauna, ciuqliq pilliuq",
        "translation": "They said that when Ississaayuk's daughter started giving things out that ship, probably the first one"
    },
    "40": {
        "startTime": 305.418,
        "endTime": 311.709,
        "transcript": "Inerqurnaurai makut tangrruaruniluki, ayakata piunrirciqniluki.",
        "translation": "She would admonish them, saying that they were illusions and would disappear when they left."
    },
    "41": {
        "startTime": 312.812,
        "endTime": 319.794,
        "transcript": "Kinguqlirkaa tau͡gaam nutaan tekiskan piyugtaciatun kiputesqelluku.",
        "translation": "He told her to buy as much as she wanted only when the next one came."
    },
    "42": {
        "startTime": 321.466,
        "endTime": 324.866,
        "transcript": "Una tua-i ciuqlikacaaq peggluku sun'aq.",
        "translation": "They abandoneed this first ship."
    },
    "43": {
        "startTime": 326.3,
        "endTime": 329.582,
        "transcript": "Qanemciuguq-gguq, qanengssaguaruuq.",
        "translation": "He said that it was only a fable."
    },
    "44": {
        "startTime": 331.803,
        "endTime": 342.949,
        "transcript": "Allamian kinguqliq-am atraan, tekican-am tuavet kicaan, qayat-am tua-i tuaten atraralliniut, Illugngali-llam ilakluku.",
        "translation": "The next year when the next one came down, arrived and anchored there, the kayaks went down like that along with Illugngali."
    },
    "45": {
        "startTime": 344.674,
        "endTime": 347.956,
        "transcript": "Tuyulillruat-gguq Illugngali tauna.",
        "translation": "They said that they were sending something to Illugngali."
    },
    "46": {
        "startTime": 350.309,
        "endTime": 360.355,
        "transcript": "Cavigpall'e'rmek-llu-gguq tangssunarqelriamek uyamilkirluku tauna Illugngali caqiqsaruarpagmek.",
        "translation": "And they say that they gave Illugngali a big beautiful metal necklace that looked like a side labret."
    },
    "47": {
        "startTime": 360.391,
        "endTime": 364.609,
        "transcript": "Tua-i-gguq tuyuliluku. Tua-i-gguq kenekluku.",
        "translation": "They say they delivered it to him. They say that they loved him."
    },
    "48": {
        "startTime": 365.317,
        "endTime": 373.617,
        "transcript": "Quuyurmeng Kass'arugaat tua-i uyangqamakiit qayami tuani cun'ami culungqallrani.",
        "translation": "The many Caucasians looked out smiling at him as he docked his kayak on that ship."
    },
    "49": {
        "startTime": 375.264,
        "endTime": 380.382,
        "transcript": "[?Taangaami-llu-gguq anevyainanermini piuq] \"eru-eru-eru.\"",
        "translation": "[?And they said that when he drank alcohol as he was going out, he was going] \"eru-eru-eru.\""
    },
    "50": {
        "startTime": 381.813,
        "endTime": 388.968,
        "transcript": "\"Tuunrangayak anaqatartuq,\" kivgani tauna Kass'aq.",
        "translation": "\"The devil is going to defecate,\" he said as he pulled down that Caucasian's pants."
    },
    "51": {
        "startTime": 389.571,
        "endTime": 392.752,
        "transcript": "Tuunrangayak-kiq camek anarniarta?",
        "translation": "I wonder what would come from the devil's bowels?"
    },
    "52": {
        "startTime": 394.719,
        "endTime": 400.356,
        "transcript": "Anarpall'e'rmek qilunguarpall'e'rmek igcian-am tauna \"ia.\"",
        "translation": "When he dropped a large cylindrical piece of feces, he went, \"Ee.\""
    },
    "53": {
        "startTime": 401.163,
        "endTime": 402.854,
        "transcript": "Anamanek-ll' anarluni.",
        "translation": "And he defecated normally."
    },
    "54": {
        "startTime": 404.017,
        "endTime": 411.508,
        "transcript": "Pikegkut-gguq quuyucuarluteng uyangqalriat iliita yaq'ercaaqaa nuryalkaqerluku.",
        "translation": "They said that one of the ones grinning looking out up there [?]."
    },
    "55": {
        "startTime": 412.462,
        "endTime": 417.553,
        "transcript": "Qutnguani-gguq tau͡gaam nacaanek qiaryarpak tegumiangqeqerluni.",
        "translation": "But they said that he was holding herring eggs in the hood of his skin parka."
    },
    "56": {
        "startTime": 419.758,
        "endTime": 425.386,
        "transcript": "Qenqertelliniuq tauna Illugngali piquarilami.",
        "translation": "Illugngali was angered because he was short tempered."
    },
    "57": {
        "startTime": 426.291,
        "endTime": 429.946,
        "transcript": "Kiituani pik'um teguliu.",
        "translation": "Eventually, one up there took him."
    },
    "58": {
        "startTime": 431.462,
        "endTime": 438.607,
        "transcript": "Tuyumtam tauna arnani tauna uyamini teguluku mer'em qainganun miluryautelliniluku.",
        "translation": "He took his woman's figted necklace and threw it into the water."
    },
    "59": {
        "startTime": 439.768,
        "endTime": 442.431,
        "transcript": "Kass'anun pikegkunun tangvagtelluni.",
        "translation": "He had the Caucasians up there watch him."
    },
    "60": {
        "startTime": 443.841,
        "endTime": 449.595,
        "transcript": "Ernerpak-gguq tang tua-i unaukumek ayagluni qanrumallrulria tauna Illugngali.",
        "translation": "They said that Illugngali talked all day starting in the morning."
    },
    "61": {
        "startTime": 449.98,
        "endTime": 455.18,
        "transcript": "Kiituani-gguq 'gguun iqrek qerruneq pu'guq, qatellriamek eltenguq.",
        "translation": "They said that eventually, something grew out of the corners of his mouth and was seeping something white."
    },
    "62": {
        "startTime": 456.264,
        "endTime": 464.1,
        "transcript": "Ulerpak-llu-gguq uleluni imumek tua-i muirumayaaq[elleq] im' enlluni.",
        "translation": "And then the tide rose, and what was full flowed out."
    },
    "63": {
        "startTime": 465.463,
        "endTime": 469.163,
        "transcript": "Acigiiluni Illugngali qanrumallrani.",
        "translation": "It lowered as Illugngali was talking."
    },
    "64": {
        "startTime": 470.869,
        "endTime": 475.497,
        "transcript": "Tuqum ciullermi taumek yaq'ercaaqesteḿinek",
        "translation": "Death came firs to the one who [?] him."
    },
    "65": {
        "startTime": 477.425,
        "endTime": 484.161,
        "transcript": "Nutaan-gguq tamakut aklut tuntullrit utertengraata piunrillrunritut.",
        "translation": "They said that even though they went home, the cargo they left didn't disappear."
    },
    "66": {
        "startTime": 486.335,
        "endTime": 495.08,
        "transcript": "Tuani-gguq tauna cun'aq ciuqliq tekiteqerraakacagalleq tayima taringumasteḿini qanertuq:",
        "translation": "They said that one who understood the very first ship that came at the time said:"
    },
    "67": {
        "startTime": 495.666,
        "endTime": 502.23,
        "transcript": "Tuunrangayak-gguq kalikartuq igartuq maaken Alaska-mek [?]qualuni.",
        "translation": "They said that the devil is writing papers from here in Alaska."
    },
    "68": {
        "startTime": 502.525,
        "endTime": 505.052,
        "transcript": "Hotel-aarluni tuunrangayak.",
        "translation": "The devil was staying in a hotel."
    },
    "69": {
        "startTime": 506.001,
        "endTime": 514.11,
        "transcript": "Mat'um-gguq tuunrangayaullgutiinek cun'amek ciuqliuluku nasvetua",
        "translation": "They say that its accompanying devil, the first ship, shows it"
    },
    "70": {
        "startTime": 515.918,
        "endTime": 519.909,
        "transcript": "Iilegmek qacarnerani qelemyaralrianek.",
        "translation": "Eyes that close on its side."
    },
    "71": {
        "startTime": 521.021,
        "endTime": 532.466,
        "transcript": "Tayima qanemcitaan ilii katagaluku niiyucirramtun qanemcikestellratun man'a qanemcikqerqa.",
        "translation": "I'm telling this story from what little I heard told to me, possibly forgetting some parts."
    },
    "72": {
        "startTime": 532.625,
        "endTime": 539.834,
        "transcript": "Ik'um kenurriurtem paqnaqkii anamek tauna analleq",
        "translation": "The electrician across there that was curious about the one who defecated"
    },
    "73": {
        "startTime": 540.636,
        "endTime": 548.054,
        "transcript": "Ava-i tua-i ayuquciatun niitellemtun, allaurrluku-ll' tua-i piyaaqaqa tua-i.",
        "translation": "I just told it how I heard it, and I probably changed it."
    },
    "74": {
        "startTime": 549.214,
        "endTime": 555.842,
        "transcript": "Camek tayima qanemcisqumasia? Ciuliamta-qaa ayuqucianek wall'u-qaa?",
        "translation": "What kind of stories do you want me to tell? What our ancestors were like or what?"
    },
    "75": {
        "startTime": 555.852,
        "endTime": 559.443,
        "transcript": "Imumi tamakut-mi tairqellrit Kass'at?",
        "translation": "What about the thigns the West brought back then?"
    },
    "76": {
        "startTime": 559.452,
        "endTime": 560.034,
        "transcript": "Ai?",
        "translation": "What?"
    },
    "77": {
        "startTime": 560.036,
        "endTime": 562.982,
        "transcript": "Tairqellrit iciw' tamakut Kass'at?",
        "translation": "You know, the things the West brought?"
    },
    "78": {
        "startTime": 563.864,
        "endTime": 564.737,
        "transcript": "Qaill' piat?",
        "translation": "What about them?"
    },
    "79": {
        "startTime": 564.752,
        "endTime": 574.78,
        "transcript": "Iciw' cat tairqellrit nutarat tamakut cat tua-i mukaat wall'u-q' saarralat wall'u-q' cat allat wani.",
        "translation": "You know, the new things that they brought like flour or sugar or other things."
    },
    "80": {
        "startTime": 574.79,
        "endTime": 576.117,
        "transcript": "Leqkat-qaa?",
        "translation": "You mean [?food]?"
    },
    "81": {
        "startTime": 576.127,
        "endTime": 578.272,
        "transcript": "Yaa, wall'u-q' piciatun aklut.",
        "translation": "Yes, or any other things."
    },
    "82": {
        "startTime": 578.454,
        "endTime": 579.691,
        "transcript": "Aklut-wa...",
        "translation": "The things..."
    },
    "83": {
        "startTime": 579.695,
        "endTime": 584.05,
        "transcript": "Massiinat-ll' iciw' levaaq wall'u-q' snowmachine.",
        "translation": "And the machines, like boat motors or snowmachines."
    },
    "84": {
        "startTime": 584.468,
        "endTime": 590.55,
        "transcript": "Massiinat tamakut ciuqliullrunricugnarqut.",
        "translation": "Those machines were probably not the first."
    },
    "85": {
        "startTime": 590.557,
        "endTime": 601.727,
        "transcript": "Yaa, tau͡gaam iciw' pugqerraallratni qaillun iciw' temcinarqellriit yuut wani irr'ikluki pillrit. Qaillun iciw' umyuarteqellrit niirqellerpenek wall'u-q' elpet.",
        "translation": "Yes, but you know, the funny ways that people were amazed by them when they first appeared. You know, what you heard about their thoughts or what you did."
    },
    "86": {
        "startTime": 603.057,
        "endTime": 607.907,
        "transcript": "Tamakut tang tua-i igvaumanrilkenka.",
        "translation": "I didn't come upon those."
    },
    "87": {
        "startTime": 608.657,
        "endTime": 617.377,
        "transcript": "Ukut tau͡gaam Kuigglugmiut yaani neqliarpek'nateng unegtellriit.",
        "translation": "But these people from Kwethluk over there were left alone without going to fish camps."
    },
    "88": {
        "startTime": 618.622,
        "endTime": 631.672,
        "transcript": "Kinguatni kanavet Curirnermun paacpakayall'er tamana, cunauvkenani paacaq teplinikii.",
        "translation": "After that, a huge barge, not a ship, a barge, drifted ashore to Curirneq down there."
    },
    "89": {
        "startTime": 632.842,
        "endTime": 637.632,
        "transcript": "Neqkanek-gguq tua-i mukaanek uciluni makunek.",
        "translation": "They said that it carried food, flour."
    },
    "90": {
        "startTime": 637.952,
        "endTime": 643.522,
        "transcript": "Caayumek-gguq tang tau͡gaam tamakut uciilangqellrunrilnguut.",
        "translation": "But they said that they did not carry tea."
    },
    "91": {
        "startTime": 645.272,
        "endTime": 649.672,
        "transcript": "Cuyamek-llu cuyapiamek kuingirkanek-gguq tau͡gaam.",
        "translation": "They said that it only had cigarettes made from real tobacco leaves."
    },
    "92": {
        "startTime": 650.317,
        "endTime": 657.267,
        "transcript": "Tuntulegtaat-gguq-am tamakut aturat ikamracuaraat-ll' assirrlainaat tuntulget.",
        "translation": "And they said that they had clothes made from caribou and good small caribou skin sleds."
    },
    "93": {
        "startTime": 658.397,
        "endTime": 666.847,
        "transcript": "Nangcautaa-gguq tau͡gaam ilavkuk unrapigartun ellegtang'e'rmi kevkautellrulliniluni.",
        "translation": "But they said that even though its seld had a rope as thick as straight spruce saplings, it snapped."
    },
    "94": {
        "startTime": 668.877,
        "endTime": 678.657,
        "transcript": "Pankaat-gguq makut kuvuurluki cat, mukaat-llu kuvuurluki caquit cailkamun-ll' anulluki katagluki.",
        "translation": "They said that they spilled various things from [the sacks], spilled flour and took out their containers and dropped them."
    },
    "95": {
        "startTime": 679.142,
        "endTime": 682.582,
        "transcript": "Caquit lumarrarkarciluki tua-i.",
        "translation": "They used their containers for sewing fabric."
    },
    "96": {
        "startTime": 683.377,
        "endTime": 690.557,
        "transcript": "Tua-i-gguq tua-i paacam uqra qengarvall'er mukaat kuv'urallrit.",
        "translation": "They said that the barge's leeward side had a huge mound of the flour they spilled."
    },
    "97": {
        "startTime": 691.322,
        "endTime": 694.922,
        "transcript": "Tauna-ll' paacam qilii qulmun kiturluku.",
        "translation": "And it surpassed the roof of that barge."
    },
    "98": {
        "startTime": 696.177,
        "endTime": 709.197,
        "transcript": "Cuirneq-gguq kan' ul'aqami ulerpagmek ernerpak tua-i mukaamek kisnengqerrluni, tua-i carvaniryaaqviminek kingupailgan entaqami.",
        "translation": "They said that when the tide came in high in Cuirneq down there, the flour would settle down all day before the current took it out as the tide went out."
    },
    "99": {
        "startTime": 709.822,
        "endTime": 716.252,
        "transcript": "Mukaaq cali taman' pugtalria tua-i nucugaqkii Cuirnermi kisneq.",
        "translation": "The floating flour would also be pulled by pulled by the sunken flour on Cuirneq."
    },
    "100": {
        "startTime": 717.262,
        "endTime": 720.812,
        "transcript": "Kingupailgan-gguq carvaninqigtaqluni.",
        "translation": "They said that before it returned, the current would flow again."
    },
    "101": {
        "startTime": 722.262,
        "endTime": 729.542,
        "transcript": "Mukaat katagluki cailkamun tamakut paankaat neqkanek imalget.",
        "translation": "They spilled out the flour to the ground from the [sacks] that were filled with food."
    },
    "102": {
        "startTime": 729.887,
        "endTime": 738.907,
        "transcript": "Cauciilamegteki kuvuurluki imait tua-i qaltarkarciaqluki-gguq, egatekarciaqluki.",
        "translation": "They spilled them out because they didn't know what they were, saying that they were going to use them for water containers and pots."
    },
    "103": {
        "startTime": 741.092,
        "endTime": 746.872,
        "transcript": "Tauna tau͡gaam cali qanengssak'laraat nalluluki cat.",
        "translation": "They only tell those stories about how they didn't know Western things."
    },
    "104": {
        "startTime": 747.167,
        "endTime": 753.227,
        "transcript": "Cuyamek-gguq tau͡gaam yuaryaaqluteng tamatum iluani angyam",
        "translation": "They said that they only looked for tobacco inside that boat"
    },
    "105": {
        "startTime": 754.542,
        "endTime": 758.072,
        "transcript": "Cuya tua-i ciumek-gguq elitellruamegteggu.",
        "translation": "Because they said they first learned how to use tobacco."
    },
    "106": {
        "startTime": 758.522,
        "endTime": 764.562,
        "transcript": "Kass'alugpiat-gguq cuyautaitnek ciumek eliteqarraallruut.",
        "translation": "They said that they first learned how to use Russian tobacco."
    },
    "107": {
        "startTime": 765.057,
        "endTime": 769.817,
        "transcript": "Kuingirkanek tau͡gaam tamakunek-gguq taman' paacaq uciluni.",
        "translation": "They said that that barge was carrying tobacco."
    },
    "108": {
        "startTime": 770.602,
        "endTime": 782.042,
        "transcript": "Caayumek-llu-gguq piinani, mat'umek-gguq tau͡gaam kuuvviarullinilriamek miilimanrilngurmek tua-i uciluni.",
        "translation": "And they said that it didn't carry tea, but carried what was apparently unground coffee."
    },
    "109": {
        "startTime": 783.477,
        "endTime": 791.757,
        "transcript": "Tamakut-gguq imkut Kass'anun ayaketaatullret elisngalriit nutaan nangengnerakun",
        "translation": "They said that those who had learned by repeatedly going to Caucasians, right when they were about to be depleted"
    },
    "110": {
        "startTime": 792.072,
        "endTime": 799.672,
        "transcript": "Paankaat-llu tamakut anulluki egqaqurallrit, masslat aciqsiginratgun",
        "translation": "And the [containers] that they took out and disposed of, when butter was getting low"
    },
    "111": {
        "startTime": 801.417,
        "endTime": 809.047,
        "transcript": "Tauna-gguq Kanaqlak angyakun tekilluni, ukut Tarruy'iinkut atiit.",
        "translation": "They said that Kanaqlak arrived on a boat, the father of Tarruy'ak and family."
    },
    "112": {
        "startTime": 810.087,
        "endTime": 822.837,
        "transcript": "Nutaan elitaqluki tamaavet angyaminun ekurian pileryagyaaqelriamun kinguraulluteng tua-i ilait pikaiteqaquluteng",
        "translation": "When he recognized them and he put them into his boat, some suddenly went to him but were late and some didn't have any"
    },
    "113": {
        "startTime": 823.637,
        "endTime": 832.727,
        "transcript": "Makunek Kass'at neqautiatnek paatkaanek, atsanek imalegnek canek, paatakaanek-llu tamakunek",
        "translation": "These Western foods like [shortening], things with berries, and syrup"
    },
    "114": {
        "startTime": 833.137,
        "endTime": 839.927,
        "transcript": "Alikelteng nerenrilkurrluki tua-i tamakut kuvuurluki.",
        "translation": "The things they didn't eat and spilled out our of fear."
    },
    "115": {
        "startTime": 842.077,
        "endTime": 849.727,
        "transcript": "Cali tua-i tuaten taktaluku au͡gna. Amllerrsaaquq qanemcikaa.",
        "translation": "That's all for that story. There's a lot to tell about it."
    },
    "116": {
        "startTime": 850.247,
        "endTime": 859.507,
        "transcript": "Ukut-gguq taukut neqlianritellret assaliarrlainarnek naterniarnanrirluteng kiagpak nertullruut",
        "translation": "They said that those who didn't go to fish camp [stopped fishing for flounders] and ate pancakes or frybread all summer"
    },
    "117": {
        "startTime": 861.592,
        "endTime": 864.532,
        "transcript": "Assalianek tamakunek.",
        "translation": "Those pancakes or frybread."
    },
    "118": {
        "startTime": 867.177,
        "endTime": 868.537,
        "transcript": "Aling aren.",
        "translation": "Oh my goodness."
    },
    "119": {
        "startTime": 869.612,
        "endTime": 877.452,
        "transcript": "Unuaqullerkaa-ll' uungicii[naku]. Mukaat-gguq-qaa tua-i caquitnun lumarrarnun cumigtellrulriit.",
        "translation": "They didn't prepare for tomorrow. They said that they focused on the flour sacks to use as sewing fabric."
    },
    "120": {
        "startTime": 879.037,
        "endTime": 882.252,
        "transcript": "Lumarraq tua-i enurnallrani tua-i pillinilriit.",
        "translation": "They did that when sewing fabric was scarce."
    },
    "121": {
        "startTime": 882.252,
        "endTime": 894.192,
        "transcript": "Mukaanek taguqurillrukuneng allrakurtaarluki imait piksarluki tamakut umyuarteqtulit.",
        "translation": "If they brought in flour every year, the wise ones would keep what was inside."
    },
    "122": {
        "startTime": 894.197,
        "endTime": 895.977,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "123": {
        "startTime": 898.962,
        "endTime": 906.152,
        "transcript": "Tagucugciurluteng tamakunek lumarrarnek tuatnallrullinilriit.",
        "translation": "They did that, wanting to bring in sewing fabric."
    },
    "124": {
        "startTime": 907.462,
        "endTime": 917.872,
        "transcript": "Makut tang tua-i levaat, massiinaat, snuukuut-llu, makut-llu levaat canimaarmi wii tangvallemni piurtellrulriit.",
        "translation": "From what I've seen, these boat motors, machines, snowgos, and these boat motors came first."
    },
    "125": {
        "startTime": 917.872,
        "endTime": 929.062,
        "transcript": "Kitak' iciw' irr'ikellratnek-qaa niitelartuten qanengssagnek temcinarqellrianek?",
        "translation": "So, you know, did you hear funny stories about the things they were amazed by?"
    },
    "126": {
        "startTime": 931.232,
        "endTime": 943.702,
        "transcript": "Una Kakianeq Mistussiikaq wani kiputelleq Anuuraami ciumek kiputeqarraallruuq wavet taivailegmi Kuigilngurmun.",
        "translation": "Kakianeq, Mistussiikaq, who traded here in Anuuraaq, he first traded before he came here to Kwigillingok."
    },
    "127": {
        "startTime": 944.952,
        "endTime": 952.612,
        "transcript": "Aklussatullruu\tq angyangqerrami malrulegpall'e'rmek aminramek amilegmek.",
        "translation": "He would get things because he had a huge double boat made of old skin."
    },
    "128": {
        "startTime": 954.447,
        "endTime": 962.377,
        "transcript": "Kuinerramun tayima tengalrarluni pellatullruuq ketmun. Cunawa ikavet Kuinerramun qerarluni.",
        "translation": "He would disappear out into the ocean with a sail to Quinhagak. Apparently, he would cross to Quinhagak."
    },
    "129": {
        "startTime": 963.277,
        "endTime": 967.267,
        "transcript": "Angayuqra-gguq tauna Mistussiikaq Kass'aq.",
        "translation": "They said his parent was a Caucasian named Mistussiikaq."
    },
    "130": {
        "startTime": 969.637,
        "endTime": 978.377,
        "transcript": "Angyani tayim' mukaanek, caarralanek, caayunek, cuyanek-llu imirluku tekitetullruuq.",
        "translation": "He would arrive having filled his boat with flour, sugar, tea, and tobacco."
    },
    "131": {
        "startTime": 981.102,
        "endTime": 989.892,
        "transcript": "Uksuarmi tau͡gken tua-i aruquteksugluki Caninermiunun qakmavet Qaluyaat qau͡gkut engel'karrluki ukatait.",
        "translation": "Yet in the fall, he would distribute them to people in the Canineq region going up north to this side of Nelson Island."
    },
    "132": {
        "startTime": 991.062,
        "endTime": 993.362,
        "transcript": "Wagg'uq akiilnguartelluki.",
        "translation": "They said he was racking credit."
    },
    "133": {
        "startTime": 995.187,
        "endTime": 1007.667,
        "transcript": "Uksu'rqan tau͡gken tua-i cikuqami akiilngurcurluki ikamrarluni ceńirrluki tamakut akiilngillret.",
        "translation": "In the winter, however, right when it froze, he collected their debt, using a sled to visit those who were indebted."
    },
    "134": {
        "startTime": 1008.842,
        "endTime": 1020.882,
        "transcript": "Tua-i-am tua-i caqerluni kiagmi aturcetaanek tekiutellria, aturcetaarullinilrianek tuqlungualegnek.",
        "translation": "One summer, he brought an instrument, what turned out to be an instrument with pipes."
    },
    "135": {
        "startTime": 1021.757,
        "endTime": 1030.497,
        "transcript": "Aturcuutait-wa tau͡gaam paankaarrarngalnguut, makut malik'itaat ayuqenrilkait.",
        "translation": "Their instruments looked like little [canisters], unlike the [?malik'itaat]."
    },
    "136": {
        "startTime": 1033.442,
        "endTime": 1046.812,
        "transcript": "Aturcetaaqata'arqan angulluange'rmeng, arnassagaunge'rmeng neqlillerni ukut Keggukarmiut tamarmeng itratullruut niicugniyarturluku.",
        "translation": "When he was going to play the instrument, everyone from Keggukarmiut, even the old men and women, would go upriver to listen to him."
    },
    "137": {
        "startTime": 1047.922,
        "endTime": 1053.702,
        "transcript": "Uaken-llu Nunapigmiunek niicugniyartulriit tekitaqluteng.",
        "translation": "And people would come from Nunapigmiut downriver to listen."
    },
    "138": {
        "startTime": 1055.387,
        "endTime": 1062.837,
        "transcript": "Atam-am piinanermini levaanek un' tekiutuq elliqeryaranek.",
        "translation": "Eventually, he brought boat motors that would just be set on their boats."
    },
    "139": {
        "startTime": 1064.887,
        "endTime": 1075.197,
        "transcript": "Arenqiapaa-ll'. Angyallugaq uciluku unani Keggukaraam iluani levaarluni angyiqtaarqan",
        "translation": "My goodness. When he loaded his big boat and was going to travel back and forth on Keggukar with a boat motor"
    },
    "140": {
        "startTime": 1075.897,
        "endTime": 1085.087,
        "transcript": "Nunat imkut ceńavarluteng tamarmeng yuita tangssuyarturaqekiit.",
        "translation": "Every person from those villages would go to the coast to watch him."
    },
    "141": {
        "startTime": 1086.617,
        "endTime": 1097.527,
        "transcript": "Una Angassaaqun angagurluqa tuntulguniluku qama-i niitaqluku, allanek call' ilaluni yugnek.",
        "translation": "I heard that my maternal uncle Angassaaqun was a reindeer herder upriver along with other people."
    },
    "142": {
        "startTime": 1099.667,
        "endTime": 1103.967,
        "transcript": "Atam-am piqerluni tauna Angassaaqun tekitellria.",
        "translation": "One day, you see, Angassaaqun arrived."
    },
    "143": {
        "startTime": 1106.152,
        "endTime": 1114.802,
        "transcript": "Tekicami-ll' tua-i taukut aturcetaat tayima, taukut-llu elliqeryarat tayima teguluki ayaulluki.",
        "translation": "And when he arrived, he took those instruments and those boat motors, then took them away."
    },
    "144": {
        "startTime": 1116.202,
        "endTime": 1121.762,
        "transcript": "Cunaw' tuntunek arnaqatagnek unguvalrianek kiputellinikai.",
        "translation": "Apparently, he traded them for live female reindeer."
    },
    "145": {
        "startTime": 1123.737,
        "endTime": 1132.547,
        "transcript": "Tuavet-ll' akemna Paru kiugna kiani Keggukaraam kiaqliani Paru Kass'aq",
        "translation": "And he went across to Paru upriver from Keggukar, the Caucasian named Paru"
    },
    "146": {
        "startTime": 1134.617,
        "endTime": 1139.817,
        "transcript": "Palayanek makunek tengalratulinek tekiutnaurtuq.",
        "translation": "He would arrive with skiffs with sails."
    },
    "147": {
        "startTime": 1140.862,
        "endTime": 1150.992,
        "transcript": "Tua-i tau͡gken ilaita kipucugtaita, tuntunek-gguq unguvalrianek arnaqatagnek tamakut kipulluki",
        "translation": "However, some of the ones who wanted to trade for them traded live female reindeer"
    },
    "148": {
        "startTime": 1151.532,
        "endTime": 1155.232,
        "transcript": "Palayat tekiuteqarraallrit.",
        "translation": "The thigns the skiffs first brought."
    },
    "149": {
        "startTime": 1158.002,
        "endTime": 1158.882,
        "transcript": "Parum.",
        "translation": "Paru did."
    },
    "150": {
        "startTime": 1160.497,
        "endTime": 1167.317,
        "transcript": "Palayanek-am tua-i tauna caaqami amllernek-llu tekiugarrnaurtuq.",
        "translation": "Once in a while, he would come on a skiff bringing many things."
    },
    "151": {
        "startTime": 1169.662,
        "endTime": 1173.902,
        "transcript": "Kass'arugarnek tangaallrunritua Kusquqvagmi.",
        "translation": "I didn't see a lot of Caucasians on the Kuskowkim."
    },
    "152": {
        "startTime": 1176.207,
        "endTime": 1186.207,
        "transcript": "Allamiaquaqan amlleriinartut Kass'at. Cun'at-ll' itqaqulriit amlleriinarluteng tua-i.",
        "translation": "Each year, there were more Caucasians. And there were more ships coming in."
    },
    "153": {
        "startTime": 1188.732,
        "endTime": 1194.222,
        "transcript": "Canek ilait cun'at assiraqluki au͡gkunek.",
        "translation": "Some of the ships brought those good things."
    },
    "154": {
        "startTime": 1194.402,
        "endTime": 1205.302,
        "transcript": "Tua-i-ll' piqerluni niitua akma-gguq Apruka'armiuni tauna Kass'aq Neqliyaq tekituq cun'arugarluni amllernek.",
        "translation": "Then one day, I heard that a Caucasian by the name of Neqliyaq arrived over in Apruka'ar with a multitude of ships."
    },
    "155": {
        "startTime": 1206.617,
        "endTime": 1219.007,
        "transcript": "Caninermiu tauna tua-i Cevv'arnermiut kiagmi neqsuraqan Isqaq kan' pelatekanek patumatullruuq kuvyastainek.",
        "translation": "When that person from Canineq fished in the summer, Isqaq down there would be covered with tents for the people of Chefornak who were drift netting."
    },
    "156": {
        "startTime": 1220.737,
        "endTime": 1232.427,
        "transcript": "Agna-llu kiatmun Apruka'armun ngelekluku pelatekat tua-i piqaquluteng Kuiguyugmiut kiugkut engelkarrluki.",
        "translation": "And across there along Apruka'ar, there would be many tents going all the way to Kuiguyugmiut."
    },
    "157": {
        "startTime": 1232.947,
        "endTime": 1237.887,
        "transcript": "Cali-w' Cingigpagmiunek kiani Anllermiuni.",
        "translation": "There were also people from Cingigpak upriver in Anllermiut."
    },
    "158": {
        "startTime": 1238.802,
        "endTime": 1240.762,
        "transcript": "Kuvyistai-gguq taum.",
        "translation": "They said they were his fishers."
    },
    "159": {
        "startTime": 1242.617,
        "endTime": 1248.177,
        "transcript": "Tua-i tang taum nutaam yuut tangnirivkallrukai.",
        "translation": "He beautified the people."
    },
    "160": {
        "startTime": 1249.982,
        "endTime": 1262.022,
        "transcript": "Aturanek makunek taqumalrianek qerrullignek angutet-ll' lumarracuarnek arnat-llu taqmagnek lumarrarnek atulangluteng.",
        "translation": "They started wearing Western made clothes, cloth pants for the men, and cloth dresses for the women."
    },
    "161": {
        "startTime": 1262.867,
        "endTime": 1266.207,
        "transcript": "Miiskaanek-llu tang qantangluteng.",
        "translation": "They also got dishpans for bowls."
    },
    "162": {
        "startTime": 1267.642,
        "endTime": 1270.892,
        "transcript": "Caaniiget-llu tua-i makut amlleriluteng.",
        "translation": "There was also an increase in kettles."
    },
    "163": {
        "startTime": 1273.382,
        "endTime": 1275.782,
        "transcript": "Tangerqaqunariluteng...",
        "translation": "They were seen everywhere..."
    }
};